query SectionsQuery {
  sections {
    order
    heName
    transliteratedName
    books {
      order
      heName
      transliteratedName
      chapters {
        chapter
        verses
      }
    }
  }
}
